'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultIcon = function DefaultIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('path', {
                d: 'M3.019 59.367l56.256-56.71v56.71H3.02zm26.126-11.98c0 .609 6.09.9 18.27.875V28.715c-12.18 11.84-18.27 18.065-18.27 18.673z',
                id: 'a'
            })
        ),
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('use', {
                fill: '#F7F7F8',
                xlinkHref: '#a'
            }),
            _react2.default.createElement('path', {
                fill: '#FFCF3F',
                d: 'M3.098 46.955L45.027 4.62l4.98-2.01-2.254 4.666L5.655 49.162H3.832z'
            }),
            _react2.default.createElement('path', {
                d: 'M6.74 41.448l-1.084 1.085-1.365-1.365 1.085-1.085 1.365 1.365zm-1.32 6.549a.934.934 0 0 1-1.289 0 .912.912 0 0 1 0-1.288l1.525-1.525 1.288 1.288-1.524 1.525zm2.646-5.223l1.288 1.288-1.084 1.085-1.289-1.288 1.085-1.085zM45.878 4.962l2.04-.752-.752 2.04L10.68 42.736l-1.288-1.288L45.878 4.962zM12.01 30.796L1.64 41.168l2.69 2.69-1.524 1.525a2.79 2.79 0 0 0 0 3.94 2.767 2.767 0 0 0 1.97.815c.744 0 1.443-.29 1.97-.816l1.524-1.524.78.779 1.325-1.326-.78-.779 1.085-1.084.779.78 1.326-1.326-.78-.78L48.784 7.284l2.301-6.241-6.24 2.302L8.066 40.123l-1.365-1.365 6.635-6.636-1.326-1.326zM58.078 13.078h-2.813v1.875h2.813v3.75h-2.813v1.875h2.813v3.75h-2.813v1.875h2.813v3.75h-2.813v1.875h2.813v3.75h-2.813v1.875h2.813v3.75h-2.813v1.875h2.813v3.75h-2.813v1.875h2.813v3.75h-2.813v1.875h2.813v3.75h-3.75v-2.813h-1.875v2.813h-3.75v-2.813h-1.875v2.813h-3.75v-2.813h-1.875v2.813h-3.75v-2.813h-1.875v2.813h-3.75v-2.813h-1.875v2.813h-3.75v-2.813h-1.875v2.813h-3.75v-2.813h-1.875v2.813h-3.75v-2.813h-1.875v2.813H4.574L58.078 4.574v8.504zm1.875 46.875V.048L.048 59.953h59.905z',
                fill: '#3F5060'
            }),
            _react2.default.createElement('path', {
                d: 'M46.828 46.828H30.797l16.03-16.031v16.03zm1.875-20.558L26.27 48.703h22.433V26.27z',
                fill: '#00D8C8'
            })
        )
    );
};

DefaultIcon.defaultProps = {
    width: '60',
    height: '60',
    viewBox: '0 0 60 60',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

var ProfileIcon = function (_React$Component) {
    _inherits(ProfileIcon, _React$Component);

    function ProfileIcon() {
        _classCallCheck(this, ProfileIcon);

        return _possibleConstructorReturn(this, (ProfileIcon.__proto__ || Object.getPrototypeOf(ProfileIcon)).apply(this, arguments));
    }

    _createClass(ProfileIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(DefaultIcon, { width: size + 'px', height: size + 'px' })
            );
        }
    }]);

    return ProfileIcon;
}(_react2.default.Component);

exports.default = ProfileIcon;